import { render, staticRenderFns } from "./DialogAssignCoordinador.vue?vue&type=template&id=526f32fa"
import script from "./DialogAssignCoordinador.vue?vue&type=script&lang=js"
export * from "./DialogAssignCoordinador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports